import React, { useState } from "react";
import UserDashboard from "./UserDashboard";
import UserOrders from "./UserOrders";
import UserAddress from "./UserAddress";
import UserProfile from "./UserProfile";
import Header from "../components/Header";
import Footer from "../components/Footer";
function UserDashboardPage() {
    const [activeTab, setActiveTab] = useState("dashboard");
    const renderContent = () => {
        switch (activeTab) {
            case "orders":
                return <UserOrders />;
            case "address":
                return <UserAddress />;
            case "profile":
                return <UserProfile />;
            case "logout":
                handleLogout();
            default:
                return <UserDashboard />;
        }
    };
    const handleLogout = () => {
        localStorage.removeItem("authToken");
        window.location.href = "/";
    };
    return (
        <div className="page-container">
            <Header />
            {/* <div className="dashboard-container">
                <div className="sidebar">
                    <h2>My Account</h2>
                    <ul>
                        <li className={activeTab === "dashboard" ? "active" : ""} onClick={() => setActiveTab("dashboard")}>Dashboard</li>
                        <li className={activeTab === "orders" ? "active" : ""} onClick={() => setActiveTab("orders")}>Orders</li>
                        <li className={activeTab === "address" ? "active" : ""} onClick={() => setActiveTab("address")}>Address</li>
                        <li className={activeTab === "profile" ? "active" : ""} onClick={() => setActiveTab("profile")}>Profile</li>
                        <li className={activeTab === "logout" ? "active" : ""} onClick={() => setActiveTab("logout")}>Logout</li>
                    </ul>
                </div>
                <div className="dashboard-content">
                    {renderContent()}
                </div>
            </div> */}
            <Footer />
        </div>
    );
}
export default UserDashboardPage;